import { render, staticRenderFns } from "./calibrationLabMessage.vue?vue&type=template&id=155085fc&scoped=true&"
import script from "./calibrationLabMessage.vue?vue&type=script&lang=js&"
export * from "./calibrationLabMessage.vue?vue&type=script&lang=js&"
import style0 from "./calibrationLabMessage.vue?vue&type=style&index=0&id=155085fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "155085fc",
  null
  
)

export default component.exports